import React, { PureComponent } from 'react';
import { styled, StyleSheet } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import { COLORS, PADDINGS } from 'theme';
import { Body } from 'view/components/text/';

@styled(
  StyleSheet({
    container: {
      width: '100%'
    },
    barFrame: {
      position: 'relative',
      width: '100%',
      height: PADDINGS.XXL,
      backgroundColor: COLORS.SAND,
      borderRadius: '0.4rem'
    },
    progressBar: {
      width: '1rem',
      height: '100%',
      transition: 'width 0.4s',
      backgroundColor: COLORS.BLUE,
      borderRadius: '0.4rem'
    },
    error: {
      backgroundColor: COLORS.RED
    },
    paused: {
      backgroundColor: COLORS.RED
    },
    percentage: {
      // ...TEXTS.CONTENT.DESCRIPTIVE_SUBTEXT_3,
      backgroundColor: COLORS.GREY_DARKEST,
      color: COLORS.WHITE,
      width: PADDINGS.XL,
      height: PADDINGS.M,
      position: 'absolute',
      display: 'flex',
      top: '7px',
      left: '44%',
      borderRadius: '0.2rem'
    },
    uploadStatus: {
      marginBottom: PADDINGS.XS,
      // ...TEXTS.APP_SEARCH.RECORD_NAME,
      fontSize: '12px'
    }
  })
)
class ProgressBar extends PureComponent {
  render() {
    const {
      percent,
      styles: s,
      isErrored,
      isPaused,
      color = '',
      children
    } = this.props;

    return (
      <Box {...s('container')}>
        <Body {...s('uploadStatus')}>{children}</Body>
        <Box {...s('barFrame')} justifyContent='start'>
          <Box
            {...s.with({
              error: isErrored,
              paused: isPaused,
              progressBar: true
            })({ width: `${percent}%`, backgroundColor: color })}
          />
          <Box {...s('percentage')} justifyContent='center' alignItems='center'>
            {percent}%
          </Box>
        </Box>
      </Box>
    );
  }
}

export default ProgressBar;
